export const sortAssetIdAndSymbolByPrice = (currentPriceCache, list) => {
    const symbolsWithPrice = [];
    if (currentPriceCache) {
        list.forEach((item) => {
            const currentPriceForStock = currentPriceCache[item.assetId]?.value;
            if (currentPriceForStock !== undefined) {
                symbolsWithPrice.push({
                    symbol: item.symbol,
                    assetId: item.assetId,
                    sharePrice: currentPriceForStock,
                });
            }
        });
    }
    const sortedListByPrice = symbolsWithPrice
        .sort((a, b) => b.sharePrice - a.sharePrice)
        .map((eachAsset) => ({
        symbol: eachAsset.symbol,
        assetId: eachAsset.assetId,
    }));
    return sortedListByPrice;
};
export const sortAssetIdAndSymbolByPriceChange = (priceChangeCache, list) => {
    const symbolsWithPriceChange = [];
    if (priceChangeCache) {
        list.forEach((item) => {
            const priceChangeForStock = priceChangeCache[item.assetId]?.value;
            if (priceChangeForStock !== undefined) {
                symbolsWithPriceChange.push({
                    symbol: item.symbol,
                    assetId: item.assetId,
                    sharePriceChangePct: priceChangeForStock,
                });
            }
        });
    }
    const sortedListByPriceChange = symbolsWithPriceChange
        .sort((a, b) => b.sharePriceChangePct - a.sharePriceChangePct)
        .map((eachAsset) => ({ symbol: eachAsset.symbol, assetId: eachAsset.assetId }));
    return sortedListByPriceChange;
};
export const sortAssetIdAndSymbolsByName = (stockMetaCache, list) => {
    const symbolsWithName = [];
    if (stockMetaCache) {
        list.forEach((item) => {
            const nameOfStock = stockMetaCache[item.assetId]?.name;
            if (nameOfStock) {
                symbolsWithName.push({
                    name: nameOfStock,
                    symbol: item.symbol,
                    assetId: item.assetId,
                });
            }
        });
    }
    const sortedListByName = symbolsWithName
        .sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    })
        .map((eachAsset) => ({ symbol: eachAsset.symbol, assetId: eachAsset.assetId }));
    return sortedListByName;
};
export const sortAssetIdAndSymbolsBySymbol = (list) => {
    const sortedListBySymbol = [...list].sort((a, b) => {
        // Push elements without a symbol to the end
        if (!a.symbol && !b.symbol) {
            return 0;
        }
        if (!a.symbol) {
            return 1;
        }
        if (!b.symbol) {
            return -1;
        }
        return a.symbol.localeCompare(b.symbol);
    });
    return sortedListBySymbol;
};
